import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BEFORE = 'BEFORE';
const AFTER = 'AFTER';
const ON = 'ON';
function getTimeDeltaFromDeltaStatus(deltaStatus, timeDelta) {
  let delta = 0;
  if (deltaStatus === BEFORE) {
    delta = Math.abs(timeDelta.delta) * -1 || -1;
  } else if (deltaStatus === AFTER) {
    delta = Math.abs(timeDelta.delta) || 1;
  }
  return timeDelta.setDelta(delta);
}
function getDeltaStatusFromTimeDelta({
  delta
}) {
  if (delta === 0) {
    return ON;
  } else if (delta < 0) {
    return BEFORE;
  } else {
    return AFTER;
  }
}
export default function TimeDeltaSelect({
  timeDelta,
  onChange,
  readOnly,
  radioLabel
}) {
  const [deltaStatus, setDeltaStatus] = useState(getDeltaStatusFromTimeDelta(timeDelta));
  const toggleGroup = /*#__PURE__*/_jsxs(UIToggleGroup, {
    name: "delta-status",
    inline: true
    // if input is too long to be inline, displays input vertically without padding issues
    ,
    className: 'flex-wrap' + (!radioLabel ? " m-top-2" : ""),
    style: {
      gap: '0 1.25em' // same as default spacing for the inline child radio's
    },
    children: [/*#__PURE__*/_jsx(UIRadioInput, {
      className: "m-left-0" // need for UIToggleGroup style to display correctly
      ,
      defaultChecked: deltaStatus === ON,
      onChange: () => {
        setDeltaStatus(ON);
        onChange(getTimeDeltaFromDeltaStatus(ON, timeDelta));
      },
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.timeDeltaSelect.radioSelect.currentDate"
      })
    }), /*#__PURE__*/_jsx(UIRadioInput, {
      className: "m-left-0",
      "data-test-id": "property-date-before-radio-input",
      defaultChecked: deltaStatus === BEFORE,
      onChange: () => {
        setDeltaStatus(BEFORE);
        onChange(getTimeDeltaFromDeltaStatus(BEFORE, timeDelta));
      },
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.timeDeltaSelect.radioSelect.subtractFromDate"
      })
    }), /*#__PURE__*/_jsx(UIRadioInput, {
      className: "m-left-0",
      "data-test-id": "property-date-after-radio-input",
      defaultChecked: deltaStatus === AFTER,
      onChange: () => {
        setDeltaStatus(AFTER);
        onChange(getTimeDeltaFromDeltaStatus(AFTER, timeDelta));
      },
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.timeDeltaSelect.radioSelect.addToDate"
      })
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [radioLabel ? /*#__PURE__*/_jsx(UIFormControl, {
      label: radioLabel,
      children: toggleGroup
    }) : toggleGroup, deltaStatus !== ON && /*#__PURE__*/_jsx(UIFormControl, {
      label: deltaStatus === BEFORE ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.timeDeltaSelect.valueSelect.days.subtractTitle"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.timeDeltaSelect.valueSelect.days.addTitle"
      }),
      children: /*#__PURE__*/_jsx(UIStepperInput, {
        "data-test-id": "delta-stepper",
        formatter: value => I18n.text('automation-ui-enrollment.timeDeltaSelect.valueSelect.valueFormatter', {
          count: value
        }),
        min: 1,
        onChange: ({
          target: {
            value
          }
        }) => onChange(getTimeDeltaFromDeltaStatus(deltaStatus,
        // UIStepperInput's type for onChange is wrong, value is a number
        timeDelta.setDelta(value))),
        readOnly: readOnly,
        value: Math.abs(timeDelta.delta)
      })
    })]
  });
}